/**
 * "Leave without saving": the officer chose to discard the unsaved Workbench.
 *
 * Clearing only the draft was not honest: the persisted graph, transactions,
 * stash and session survived in sessionStorage (and the stores in module
 * memory), so the canvas came back on the next visit. This empties the stores
 * first (so their persist middleware writes empty state) and then removes every
 * Workbench key, including the investigation results and the camera memory.
 */

import { useGraphStore } from '../stores/useGraphStore';
import { useStashStore } from '../stores/useStashStore';
import { useTransactionStore } from '../stores/useTransactionStore';
import { useSelectionStore } from '../stores/useSelectionStore';
import { useWorkbenchSessionStore } from '../stores/useWorkbenchSessionStore';
import { useInvestigationResultsStore } from '../stores/useInvestigationResultsStore';
import { beginControlledWrite, endControlledWrite } from '../services/canvasControlledWrite';
import { removeWorkbenchSessionKeys } from '../data/workbenchDraft';

export function discardWorkbenchSession(): void {
    beginControlledWrite();
    try { useGraphStore.getState().setElements([]); } finally { endControlledWrite(); }
    useGraphStore.getState().clearHistory();
    useStashStore.getState().clearAll();
    useTransactionStore.getState().clearAll();
    useSelectionStore.getState().clearSelection();
    useWorkbenchSessionStore.getState().reset();
    useInvestigationResultsStore.getState().clear();
    removeWorkbenchSessionKeys();
}
